<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass, {'full-screen': $store.state.app.todoFullScreen}]"
  >
    <div>
      <portal-target
        name="content-renderer-sidebar-header"
        slim
      />
    </div>

    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <div
        class="content-area-wrapper"
        :class="contentWidth === 'boxed' ? 'container p-0' : null"
      >
        <slot name="breadcrumb">
          <app-breadcrumb />
        </slot>

        <portal-target
          name="content-renderer-sidebar-left"
          slim
        />
        <div class="content-right">
          <div class="content-wrapper">
            <div class="content-body">
              <slot />
            </div>
          </div>
        </div>

        <portal-target
          name="content-renderer-sidebar-right"
          slim
        />
      </div>
    </transition>

    <div>
      <portal-target
        name="content-renderer-sidebar-footer"
        slim
      />
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  components: {
    AppBreadcrumb,
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style lang="scss" scoped>
.full-screen {
  margin: 0;
  z-index: 1035;
  .content-area-wrapper {
    position: fixed !important;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100% !important; // 100vh -> 100%
  }
}
</style>
